import React, { useState } from "react";

import { getAutomationDataAttr } from "@/utils/automationUtils";
import images from "@/utils/images";

import "../styles.scss";
import NPSSurvey from "../../NPSSurvey";

import { useTaskList } from "./hooks/useTaskList";

export function TasksWidget({ profile }) {
  const [showYourTasksPopUp, setShowYourTasksPopUp] = useState(false);
  const [showNPSSurvey, setShowNPSSurvey] = useState(false);

  const { taskCount, tasks } = useTaskList({ profile, setShowNPSSurvey });

  return (
    <>
      <div
        className="dashboard-widget-card dashboard-widget-card-sm dashboard-widget-card-sec px-lg-3 px-md-2 px-3 py-2 mb-3 text-white"
        {...getAutomationDataAttr("tasks-widget")}
      >
        <div className="fs-lg-22 fs-20 mb-1 d-inline-flex tw:font-bold">
          Your Tasks{" "}
          {taskCount > 0 && <span className="fs-14 item-count item-count-sec">{taskCount}</span>}
        </div>

        {taskCount === 0 && <NoTasks />}
        {taskCount !== 0 && <TasksList isViewAll={window.innerWidth <= 768} tasks={tasks} />}

        {taskCount > 2 && window.innerWidth > 768 && (
          <div
            className="widget-view-all d-flex fs-14 cursor Btn-xs-2 tw:font-bold"
            onClick={() => setShowYourTasksPopUp(!showYourTasksPopUp)}
            role="button"
          >
            <img alt="+" src={images("./icons/common/view-all-white.svg")} />
            <div className="mt-1 ml-1">View All</div>
          </div>
        )}
      </div>

      {showYourTasksPopUp && (
        <TasksPopUp
          closeHandler={() => setShowYourTasksPopUp((previous) => !previous)}
          tasks={tasks}
        />
      )}

      {showNPSSurvey && <NPSPopUp closeHandler={() => setShowNPSSurvey((previous) => !previous)} />}
    </>
  );
}

function NoTasks() {
  return (
    <div className="text-center mt-lg-4 mt-md-2 mt-0 mx-4">
      <div className="fs-16 tw:font-bold">No New Tasks</div>
      <div className="fs-14 pb-md-0 pb-3 tw:leading-4.5">
        Tasks requested by your aptihealth care team will appear here.
      </div>
    </div>
  );
}

function NPSPopUp({ closeHandler }) {
  return (
    <div className="popup-outer" style={{ zIndex: 1001 }}>
      <div className="popup-inner p-4">
        <div className="d-flex justify-content-between">
          <div className="text-left fs-22 pb-2 m-0 tw:font-bold">Survey</div>
          <div className="close-popup-button" onClick={closeHandler}>
            <img alt="x" src={images("./icons/cross-white-sm.svg")} />
          </div>
        </div>

        <div className="widget-border" style={{ margin: 0 }} />
        <NPSSurvey />
      </div>
    </div>
  );
}

function TasksList({ isModal = false, isViewAll = false, tasks }) {
  return (
    <ul
      className="tw:mt-2 tw:flex tw:flex-col tw:gap-4"
      {...getAutomationDataAttr("tasks-widget-task-list")}
    >
      {tasks.slice(0, !isViewAll ? 2 : tasks.length).map((task, taskIndex) => {
        return (
          <li
            key={`task-${taskIndex}`}
            {...getAutomationDataAttr(`tasks-widget-task-${taskIndex}`)}
          >
            <div className="d-flex cursor" onClick={task.action ? task.action : null} role="button">
              <div className="pr-lg-3 pr-2">
                <div className="task-icon-background">
                  <div className="task-icon-container">
                    {task.icon && <img alt={taskIndex} src={images(task.icon)} />}

                    {!task.icon && (
                      <img
                        alt={taskIndex}
                        src={images(
                          isModal
                            ? "./icons/common/task/task-sec-white.svg"
                            : "./icons/common/task/task-white-sec.svg",
                        )}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="fs-16 mt-2 widget-item-txt-wrapper tw:font-bold">
                <div
                  className="fs-16 widget-item-txt tw:font-bold"
                  {...getAutomationDataAttr(`tasks-widget-task-${taskIndex}-name`)}
                >
                  {task.name}
                </div>
                <div>{task.customElement}</div>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}

function TasksPopUp({ closeHandler, tasks }) {
  return (
    <div className="popup-outer">
      <div className="popup-inner p-4">
        <div className="d-flex justify-content-between">
          <div className="text-left fs-22 pb-2 m-0 tw:font-bold">My Tasks</div>
          <div className="close-popup-button" onClick={closeHandler}>
            <img alt="x" src={images("./icons/cross-white-sm.svg")} />
          </div>
        </div>

        <div className="widget-border" style={{ margin: 0 }} />
        <TasksList isModal={true} isViewAll={true} tasks={tasks} />
      </div>
    </div>
  );
}
